// Actions
import { ActionType } from "@ms/planner-actions/lib/local/ActionType";
/** A tuple of the supported ActionType values for TaskStore, for use in the registry */ export const TaskStoreActionTypes = [
    ActionType.CreateEntityAction,
    ActionType.CreateEntityFailedAction,
    ActionType.CreateEntitySucceededAction,
    ActionType.DeleteEntityAction,
    ActionType.DeleteEntityFailedAction,
    ActionType.DeleteEntitySucceededAction,
    ActionType.DeltaSyncAction,
    ActionType.DeltaSyncSucceededAction,
    ActionType.DeltaSyncFailedAction,
    ActionType.UpdateEntityAction,
    ActionType.UpdateEntityFailedAction,
    ActionType.UpdateEntitySucceededAction,
    ActionType.FetchEntityAction,
    ActionType.FetchEntityFailedAction,
    ActionType.FetchEntitySucceededAction,
    ActionType.FetchEntityCollectionAction,
    ActionType.FetchEntityCollectionFailedAction,
    ActionType.FetchEntityCollectionSucceededAction,
    ActionType.UndeleteTaskAction,
    ActionType.UndeleteTaskFailedAction,
    ActionType.UndeleteTaskSucceededAction,
    ActionType.FetchLoopPageUrlForTaskAction,
    ActionType.FetchLoopPageUrlForTaskFailedAction,
    ActionType.FetchLoopPageUrlForTaskSucceededAction,
    ActionType.UpdateBulkEditStatusAction,
    ActionType.SetSortCriteriaAction,
    ActionType.SetTaskFilterAction,
    ActionType.SetTaskGroupingStateAction,
    ActionType.NavigateToView,
    ActionType.SetDefaultPlanAction,
    ActionType.SetFlaggedEmailPlanAction,
    ActionType.ReportValidBucketsAction,
    ActionType.ReportValidCustomFieldDefinitionsAction,
    ActionType.ReportValidGoalsAction
];
